// Filter/enum values must match the proto enums in news-queue-service
// (DealType / SortByDate / GroupBy / RecordDealReviewOutcomeRequest.Outcome).
// Requests send the integer value; responses serialize enums as their string NAME
// (proto3 JSON), so DEAL_TYPE_LABEL is keyed by name.

export const DEAL_TYPE_OPTIONS = [
  { label: 'All', value: 0 },
  { label: 'Funding', value: 1 },
  { label: 'M&A', value: 2 },
];

// Date direction for the queue ordering.
export const SORT_BY_DATE_OPTIONS = [
  { label: 'Oldest first', value: 1 },
  { label: 'Newest first', value: 2 },
];

// Adjacency, not a separate sort: within the date order above, keep a company's
// (or article's) deals shown together. Surfaced in the UI as a "Keep together"
// control. "Don't group" is a plain global date sort.
export const GROUP_BY_OPTIONS = [
  { label: "Don't group", value: 0 },
  { label: 'Company', value: 1 },
  { label: 'Article', value: 2 },
];

// DateField enum: which column the date range filters on.
export const DATE_FIELD_OPTIONS = [
  { label: 'Deal date', value: 1 }, // DATE_FIELD_DEAL
  { label: 'Extracted date', value: 2 }, // DATE_FIELD_EXTRACTED
];

// CompanyCategory enum: a named company category backed by a server-side predicate.
export const COMPANY_CATEGORY_OPTIONS = [
  { label: 'All companies', value: 0 }, // COMPANY_CATEGORY_UNSPECIFIED
  { label: 'Public companies only', value: 1 }, // COMPANY_CATEGORY_PUBLIC
];

export const DEAL_OUTCOME = {
  PUBLISHED: 1,
  REJECTED: 2,
  SKIPPED: 3,
  DRAFTED: 4, // saved as a funding draft; finalizes the deal without an id_funding
  MERGED: 5, // merged into an existing published funding as new evidence (requires idFunding)
};

// BroadcastChannel name used to sync deal-review state across tabs (the funding admin opens in a new
// tab, so a deal published there tells the queue tab to drop the card). Payload: { type, idNewsDeal }.
export const DEAL_REVIEW_CHANNEL = 'deal-review-outcome';

export const DEAL_TYPE_LABEL: Record<string, string> = {
  DEAL_TYPE_UNSPECIFIED: 'Unspecified',
  DEAL_FUNDING: 'Funding',
  DEAL_MA: 'M&A',
};

// Response enum may arrive as a name ("DEAL_FUNDING") or, defensively, an int.
export function dealTypeLabel(dealType: string | number | undefined): string {
  if (typeof dealType === 'number') {
    if (dealType === 1) return 'Funding';
    if (dealType === 2) return 'M&A';
    return 'Unspecified';
  }
  return DEAL_TYPE_LABEL[dealType || 'DEAL_TYPE_UNSPECIFIED'] || 'Unspecified';
}
